<template>
    <button type="button" v-if="$page.props.user" class="btn btn-gradient-primary fs-15 px-5 py-3 rounded-4" data-bs-toggle="modal"
        data-bs-target="#modalRentEnquiry">
        Rent Car Enquiry
    </button>

    <Link :href="route('user.login')" v-else class="btn btn-gradient-primary fs-15 px-5 py-3 rounded-4">
        Rent Car Enquiry
    </Link>

    <div class="modal fade" id="modalRentEnquiry" tabindex="-1" role="dialog" aria-labelledby="modalRentEnquiryLabel"
        aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable" role="document">
            <div class="modal-content px-4 py-3 rounded-4 border bg-white">
                <div class="modal-header d-flex justify-content-between border-0 pb-0">
                    <span class="modal-title fs-26 ff-dsb text-primary" id="modalRentEnquiryLabel">Rent Car
                        Enquiry</span>
                    <span type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                        <i class="far fa-times fs-18"></i>
                    </span>
                </div>
                <div class="modal-body">
                    <form @submit.prevent="submitEnquiry">
                        <div class="form">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="form-label">Name  <sup class="text-danger">*</sup></label>
                                        <input type="text" name="enquiry_name" id=""
                                            :class="{ 'is-invalid': errors.enquiry_name }"
                                            v-model="submitEnquiryForm.enquiry_name" class="form-control rounded-3 p-2">
                                        <div v-if="errors.enquiry_name" class="invalid-feedback">
                                            {{ errors.enquiry_name }}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="form-label">Email Address  <sup class="text-danger">*</sup></label>
                                        <input type="text" name="enquiry_email" id=""
                                            :class="{ 'is-invalid': errors.enquiry_email }"
                                            v-model="submitEnquiryForm.enquiry_email"
                                            class="form-control rounded-3 p-2">
                                        <div v-if="errors.enquiry_email" class="invalid-feedback">
                                            {{ errors.enquiry_email }}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group pt-md-3">
                                        <label class="form-label">Phone Number  <sup class="text-danger">*</sup></label>
                                        <input type="text" name="enquiry_phone_number" id=""
                                            :class="{ 'is-invalid': errors.enquiry_phone_number }" @input="submitEnquiryForm.enquiry_phone_number = $filters.validateNumberInput(submitEnquiryForm.enquiry_phone_number)"
                                            v-model="submitEnquiryForm.enquiry_phone_number"
                                            class="form-control rounded-3 p-2">
                                        <div v-if="errors.enquiry_phone_number" class="invalid-feedback">
                                            {{ errors.enquiry_phone_number }}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group pt-md-3">
                                        <label class="form-label">State  <sup class="text-danger">*</sup></label>
                                        <select name="enquiry_state" id="" class="form-control slot"
                                            :class="{ 'is-invalid': errors.enquiry_state }"
                                            v-model="submitEnquiryForm.enquiry_state">
                                            <option value="">Please Select</option>
                                            <option :value="key" v-for="(slot, key) in $page.props.locations">{{ slot }}
                                            </option>
                                        </select>

                                        <div v-if="errors.enquiry_state" class="invalid-feedback">
                                            {{ errors.enquiry_state }}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group pt-md-3">
                                        <label class="form-label">City  <sup class="text-danger">*</sup></label>
                                        <input type="text" name="enquiry_city" id=""
                                            :class="{ 'is-invalid': errors.enquiry_city }"
                                            v-model="submitEnquiryForm.enquiry_city" class="form-control rounded-3 p-2">
                                        <div v-if="errors.enquiry_city" class="invalid-feedback">
                                            {{ errors.enquiry_city }}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group pt-md-3">
                                        <label class="form-label">Renting Period  <sup class="text-danger">*</sup></label>
                                        <Flatpickr @data-from-child="handleDataFromChild" :mode="'range'"
                                            :hasError="(errors.rent_from || errors.rent_to) ? true : false" />
                                        <div v-if="errors.rent_from || errors.rent_to" class="invalid-feedback">
                                            A valid Renting Period is required.
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group pt-md-3">
                                        <label class="form-label">Message</label>
                                        <textarea name="enquiry_message" id="" class="form-control" rows="4"
                                            :class="{ 'is-invalid': errors.enquiry_message }"
                                            v-model="submitEnquiryForm.enquiry_message"></textarea>

                                        <div v-if="errors.enquiry_message" class="invalid-feedback">
                                            {{ errors.enquiry_message }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="pt-4 hstack gap-3 justify-content-center flex-wrap">
                            <button type="button" id="closeModal"
                                class="btn-secondary rounded-3 btn py-2 fs-15 px-5 flex-sm-grow-0 flex-grow-1"
                                data-bs-dismiss="modal">Close</button>
                            <button type="submit" class="btn-gradient-primary rounded-3 btn py-2 fs-15 px-5 flex-sm-grow-0 flex-grow-1"
                                :disabled="submitEnquiryForm.processing">
                                Confirm <i v-if="submitEnquiryForm.processing"
                                    class="fad fa-spinner-third fa-spin"></i></button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue';
import { usePage, useForm } from '@inertiajs/vue3';
import Flatpickr from '../../../../../../resources/js/front/Components/Flatpickr.vue';
import { Link } from '@inertiajs/vue3';

const props = defineProps({ errors: Object })
let selectedDate = ref('');

const page = usePage();


let submitEnquiryForm = useForm({
    enquiry_name: page.props.user ? page.props.user.name : null,
    enquiry_email: page.props.user ? page.props.user.email : null,
    enquiry_phone_number: page.props.user ? page.props.user.contact_no : null,
    enquiry_state: '',
    enquiry_city: null,
    enquiry_period: null,
    enquiry_message: null,
    vehicle_id: page.props.vehicle.id,
});

const isModalOpen = ref(false);

const openModal = () => {
    isModalOpen.value = true;
};

const closeModal = () => {
    isModalOpen.value = false;
};


const handleDataFromChild = (data) => {
    selectedDate = data.value;  // Get data from child
};

const submitEnquiry = function () {
    submitEnquiryForm.enquiry_period = selectedDate;
    submitEnquiryForm.post(route('front.enquiry.renting'), {
        preserveScroll: true,
        onSuccess: () => {
            const closeModal = document.getElementById('closeModal');
            const clearDate = document.getElementById('clearDate');
            selectedDate = null;
            closeModal.click();
            clearDate.click();
            submitEnquiryForm.reset();
        },
    });
};

</script>
